export var optionEqualsBrazil = function (option) {
    return (option === null || option === void 0 ? void 0 : option.label.toLowerCase()) === "brasil" ||
        (option === null || option === void 0 ? void 0 : option.label.toLowerCase()) === "brazil";
};
export var genericTypeEqualsBrazil = function (genericType) {
    return (genericType === null || genericType === void 0 ? void 0 : genericType.description.toLowerCase()) === "brasil" ||
        (genericType === null || genericType === void 0 ? void 0 : genericType.description.toLowerCase()) === "brazil";
};
export var filterGenericTypesBrazil = function (genericTypes) { return genericTypes === null || genericTypes === void 0 ? void 0 : genericTypes.find(genericTypeEqualsBrazil); };
export var filterOptionsBrazil = function (options) {
    return options === null || options === void 0 ? void 0 : options.find(optionEqualsBrazil);
};
